<template>
    <div class="image-container">
        <img
            ref="image"
            :src="imageSource"
            :style="imageStyle">
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: [String, Number],
            default: null
        },
        alternateSource: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            windowHeight: 0,
            imageHeight: 0,
        }
    },
    computed: {
        imageSource() {
            return this.alternateSource
                ? this.alternateSource+this.id
                : '/api/Files/Download/'+this.id;
        },
        imageStyle() {
            if (this.imageHeight === 0) {
                return {
                    width: '100%',
                    height: 'auto'
                };
            }
            const parentRatio = this.$refs.image.clientWidth / this.imageHeight;
            const viewportRatio = this.$refs.image.parentElement.clientWidth
                / this.windowHeight;
            if (parentRatio < viewportRatio) {
                return {
                    height: '100vh',
                    width: 'auto'
                };
            } else {
                return {
                    width: '100%',
                    height: 'auto'
                };
            }
        }
    },
    mounted() {
        window.addEventListener('resize', this.updateSizes);
        setTimeout(() => {
            this.updateSizes();
        }, 100);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateSizes);
    },
    methods: {
        updateSizes() {
            this.windowHeight = window.innerHeight;

            if (this.$refs.image) {
                this.imageHeight = this.$refs.image.clientHeight;
            }
        }
    }
}
</script>

<style scoped>
.image-container {
    position: relative;
}
</style>
